import React from 'react'
import './loader.scss'
const Loader = () => {
    return (
        <div>
            <div id='outer'>
                <div id='middle'>

                    <div id='inner'>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Loader
